<template>
	<div class="container">
		<device-list
			class="device-list"
			:show-nested="true"
			:fn-click-item="selectDevice"
		/>
	</div>
</template>

<style lang="scss" scoped>
.container {
	position: relative;
	max-width: 100%;
	min-height: 100%;
	padding: 0 20px 0;

	@media #{map-get($display-breakpoints, "md-and-up")} {
		padding: 0 24px 20px;
	}

	.device-list {
		padding: 8px 0;
	}
}
</style>

<script>
import _ from "lodash";

export default {
	props: ["value"],

	methods: {
		selectDevice(device) {
			const guid = _.get(device, "meta.guid");
			this.$emit("input", guid);
		},
	},
};
</script>
